var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"id":"app"}},[_c('meta',{attrs:{"name":"viewport","content":"height=device-height, width=device-width, initial-scale=1.0, minimum-scale=1.0, target-densitydpi=device-dpi"}}),_c('v-main',{attrs:{"app":""}},[_c('BuycoAppBar'),_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }